import { SimpleDataStore, useMemoryData } from '../storage/index.js';
export const requestContextStore = useMemoryData('crystal-request-context', () => new SimpleDataStore());
export function getRequestContext() {
    return requestContextStore().get();
}
//# sourceMappingURL=request-context.js.map